import React from 'react';

import PropTypes from 'prop-types';

import { Container } from './styles';

function ReleaseLayout({ children }) {
  return <Container>{children}</Container>;
}

ReleaseLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ReleaseLayout;
